import { Action, initialState, State } from "store/store";

export const setExit = (state: State = initialState, { data }: Action) => {
  return {
    ...state,
    exit: data
  };
};